<template lang="pug">
  el-select.TelSelect(v-model="countryTelCode" :value="countryTelCode")
    el-option-group(v-for="countryGroup in countryGroups" :key="countryGroup.label" :label="countryGroup.label")
      el-option(v-for="country in countryGroup.countries" :key="country.code" :value="'+' + country.dialCode"
        :label="'+' + country.dialCode")
        .option
          .flag-box
            .iti-flag(:class="country.code")
          .country {{ country.name }}
          .code +{{ country.dialCode }}
</template>

<script>
  import countries from "@/utils/countryList";
  export default {
    name: "TelSelect",
    model: {
      prop: 'telCode',
      event: 'change',
    },
    props: {
      telCode: {type: String, request: true, default: '+86'},
    },
    data() {
      return {
        countryGroups: [
          {countries},
        ],
      };
    },
    computed: {
      countryTelCode: {
        get() {
          return this.telCode;
        },
        set(val) {
          this.$emit('change', val);
          this.excode(val);
        }
      }
    },
    methods: {
      excode(telCode) {
        for (const key in countries) {
          if ('+' + countries[key].dialCode === telCode) {
            this.$emit('excode', _.cloneDeep(countries[key]));
            break;
          }
        }
      },
    },
    created() {
    },
    mounted() {
    },
  };
</script>

<style scoped lang="stylus">
  @import "../assets/css/intl.css"
  .TelSelect {
  
  }
  .option {
    display flex
    align-items center
    justify-content space-around
    .country {
      margin-left 10px
    }
    .code {
      flex-grow 2
      text-align right
    }
  }
  @media (max-width screenWidth) {
  }
</style>
